module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAAjElEQVR4Ae3LMQ7BMRQG8LqC3RFcx2gw6au81+8Lm9ER/GeJIziKK0gkFokDSLWRmhpdDYbf+HNiPIvi0uKV9xUwzVzlvCIJOWkyPr3x9kk1ZK6lhID1rKZeKFKIXCwVgygeKaXR1xAigxgPhTdeg2HTDq1s2Ipy9w8/FMQ47/HK/TtEMqdjjyhOAMYvP2AtP/3h8XgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./resources/images/document_1x.png
// module id = 2292
// module chunks = 0